// extracted by mini-css-extract-plugin
export var lg = "_19-4";
export var md = "_19-3";
export var sm = "_19-2";
export var xs = "_19-1";
export var xxs = "_19-0";